// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__BV4PS","file":"styles_file__1JM1z"};